module.exports = __webpack_public_path__ + "static/media/29_CORTININHA_SEM_BOJO_BICOLOR_01.80fafbcc.jpg";